export class Menu {
  id: string;
  name: string;
  path: string;
  isSgc1Url: boolean;
  menus: Menu[];
}